import { Helpers } from '../../helpers';
import { ITypeCurve } from '../../interfaces/itype-curve';
import { Area } from '../area';
import { AssetTeam } from '../asset-team';
import { Case } from '../case';
import { ForecastHorizontal } from '../forecast-horizontal';
import { TargetFormation } from '../target-formation';
import { TypeCurveParameter } from '../type-curve-parameter';
import { TypeCurveRisking } from '../type-curve-risking';
import { TypeCurveScaling } from '../type-curve-scaling';
import { Well } from '../well';

export class TypeCurveBase {
  TypeCurveId: number;
  Name: string;
  Remark: string | null;
  AssetTeamId: number;
  Created: Date;
  Updated: Date;
  CreatedByUID: string;
  UpdateByUID: string;
  SortOrder: number | null;
  IsActive: boolean | null;
  TargetFormationId: number | null;
  CaseId: number | null;
  ForecastHorizontalId: number | null;
  TypeCurveAreaId: number | null;
  CreatedBy: string | null;
  UpdatedBy: string | null;

  TypeCurveParameters_TypeCurve?: Array<TypeCurveParameter> | null;
  TypeCurveRisking_TypeCurve?: Array<TypeCurveRisking> | null;
  TypeCurveScaling_TypeCurve?: Array<TypeCurveScaling> | null;
  Wells_TypeCurve?: Array<Well> | null;
  AssetTeam?: AssetTeam;
  Case?: Case;
  ForecastHorizontal?: ForecastHorizontal;
  TargetFormation?: TargetFormation;
  Area?: Area;

  constructor(item?: ITypeCurve) {
    if (item) {

      this.TypeCurveId = item.TypeCurveId;
      this.Name = item.Name;
      this.Remark = item.Remark;
      this.AssetTeamId = item.AssetTeamId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedByUID = item.CreatedByUID;
      this.UpdateByUID = item.UpdateByUID;
      this.SortOrder = item.SortOrder;
      this.IsActive = item.IsActive;
      this.TargetFormationId = item.TargetFormationId;
      this.CaseId = item.CaseId;
      this.ForecastHorizontalId = item.ForecastHorizontalId;
      this.TypeCurveAreaId = item.TypeCurveAreaId;
      this.CreatedBy = item.CreatedBy;
      this.UpdatedBy = item.UpdatedBy;

      this.TypeCurveParameters_TypeCurve = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_TypeCurve);
      this.TypeCurveRisking_TypeCurve = Helpers.createClassArray(TypeCurveRisking, item.TypeCurveRisking_TypeCurve);
      this.TypeCurveScaling_TypeCurve = Helpers.createClassArray(TypeCurveScaling, item.TypeCurveScaling_TypeCurve);
      this.Wells_TypeCurve = Helpers.createClassArray(Well, item.Wells_TypeCurve);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.Case = new Case(item.Case);
      this.ForecastHorizontal = new ForecastHorizontal(item.ForecastHorizontal);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
      this.Area = new Area(item.Area);
    }
  }
}